import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Clock, MapPin, Wrench, Calendar, Handshake, MessageCircle } from 'lucide-react';
const reasons = [{
  icon: <Clock size={28} data-id="element-285" />,
  title: '12+ Years Experience',
  description: 'Real knowledge, real results'
}, {
  icon: <MapPin size={28} data-id="element-286" />,
  title: '2-State Coverage',
  description: 'Illinois & Wisconsin, one contact'
}, {
  icon: <Wrench size={28} data-id="element-287" />,
  title: 'Full-Service',
  description: 'No need to hire multiple companies'
}, {
  icon: <Calendar size={28} data-id="element-288" />,
  title: 'Year-Round Service',
  description: 'Every season, every need covered'
}, {
  icon: <Handshake size={28} data-id="element-289" />,
  title: 'Personal Accountability',
  description: "Pancho's name is on every job"
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    scale: 0.95
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.4
    }
  }
};
export function WhyPanchosSection() {
  return <section id="why-us" className="py-24 bg-cream-100" data-id="element-290">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-291">
        <div className="text-center mb-16" data-id="element-292">
          <h2 className="text-sm font-bold tracking-widest text-forest-700 uppercase mb-3" data-id="element-293">
            The Difference
          </h2>
          <h3 className="text-3xl md:text-5xl font-heading font-bold text-earth-900" data-id="element-294">
            Why Choose Pancho's
          </h3>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-295">
          {reasons.map((reason, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-6 rounded-2xl shadow-sm border border-cream-200 flex items-start gap-5" data-id="element-296">
              <div className="bg-cream-100 text-forest-700 p-3 rounded-xl shrink-0" data-id="element-297">
                {reason.icon}
              </div>
              <div data-id="element-298">
                <h4 className="text-lg font-bold text-earth-900 mb-1" data-id="element-299">
                  {reason.title}
                </h4>
                <p className="text-gray-600" data-id="element-300">{reason.description}</p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}